import { v4 as uuid } from 'uuid';

export const appId = uuid();

export const DEFAULT_REDIRECT_TIMEOUT = 3;
